/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export interface INumberLocaleUnits {
	zero: string;
	one: string;
	two: string;
	more: string;
}

export function numberToLocaleUnit(value: number, units: INumberLocaleUnits): string {
	if (value > 4) {
		return units.more;
	} else if (value > 1) {
		return units.two;
	} else if (value > 0) {
		return units.one;
	} else {
		return units.zero;
	}
}
